/**
 * 服务排序列表
 */
import React from 'react';
import DragSortTable from "../../dragSortComponent/DragSortTable";
import moveIcon from "../../../view/components/storySortModal/image/icon_5@2x.png";

export default class ServeSortTable extends DragSortTable {

    getSortColumns = () => {
        const sortColumns = [
            {
                title: "服务名称",
                dataIndex: "urlName",
                key: "urlName",
                ellipsis: true
            },
            {
                title: "服务地址",
                dataIndex: "urlAddress",
                key: "urlAddress",
                ellipsis: true
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => {
                    return <>
                        <img alt={"拖动排序"} src={moveIcon} style={{width: 20, marginTop: -2, marginRight: 5}}/>
                        <span style={{color: '#0050B3'}}>拖动排序</span>
                    </>
                }
            }
        ];
        this.setState({
            sortColumns
        });
    };

    getSortList() {
        this.request({
            url: "/cm-sites-mmp/homepageUrl/all",
            method: "get",
            callBack: data => {
                let sortList = [];
                if (data && data.length) {
                    sortList = data;
                }
                this.setState({
                    sortList
                })
            }
        });
    }

}